<marquee>
    <span *ngFor="let tickerData of ticker">
        <span *ngIf=" tickerData._beginingToEnd ==1 
                      || ( tickerData._beginingToEnd ==0 
                      && (tickerData._startDateTime < currentTime
                      && tickerData._endDateTime > currentTime) ) " class="mr-5">
            {{tickerData?._title}}
        </span>
    </span>
</marquee>